import styles from '@/components/models/accommodation/AccommodationDetailed/AccommodationDetailed.module.scss'
import accommodationObject from '@/entities/accommodation/interface'
import accommodationRoomTypeObject from '@/entities/accommodationRoomType/interface'
import AccommodationRoomType from '@/components/models/accommodation/AccommodationDetailed/AccommodationRoomType'
import AccommodationAvailableAddons from '@/components/models/accommodation/AccommodationDetailed/AccommodationAvailableAddons'
import GallerySlider from '@/components/models/media/GallerySlider'
import { Card, Col, Container, Row } from 'react-bootstrap'
import CloudinaryImage from '@/components/elements/media/CloudinaryImage'
import StarRatingDisplay from '@/components/elements/starRating/StarRatingDisplay'

interface Props {
  accommodation: accommodationObject
  roomTypes: accommodationRoomTypeObject[]
  detailed?: boolean
  imagePosition?: 'left' | 'right'
}
const AccommodationDetailed = ({ accommodation, roomTypes, detailed = true, imagePosition = 'left' }: Props) => {
  let mainImageComponent = <></>
  if (accommodation.gallery.images.length) {
    mainImageComponent = (
      <CloudinaryImage
        image={accommodation.gallery.images[0]}
        altDefault={accommodation.name}
        aspectRatio={1.6}
        width={1000}
        responsive={false}
        className={'card-img'}
      />
    )
  }

  return (
    <>
      <Container className={styles.root}>
        <Row>
          <Col>
            <Card className={`mb-5`}>
              <Row className={'h-100'}>
                {imagePosition === 'left' ? (
                  <>
                    <Col xl={6}>
                      <div className="box-ratio-16-9">
                        <div className={`box-ratio-inner ${styles.imgWrap}`}>{mainImageComponent}</div>
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Card.Body className={styles.cardBody}>
                        <div className={`${styles.stars} clearfix`}>
                          <StarRatingDisplay starsValue={accommodation.stars as unknown as string} />
                        </div>
                        <Card.Title>{accommodation.name}</Card.Title>
                        <Card.Text dangerouslySetInnerHTML={{ __html: accommodation.description }} />
                      </Card.Body>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col xl={6}>
                      <Card.Body className={styles.cardBody}>
                        <div className={`${styles.stars} clearfix`}>
                          <StarRatingDisplay starsValue={accommodation.stars as unknown as string} />
                        </div>
                        <Card.Title>{accommodation.name}</Card.Title>
                        <Card.Text dangerouslySetInnerHTML={{ __html: accommodation.description }} />
                      </Card.Body>
                    </Col>
                    <Col xl={6}>
                      <div className="box-ratio-16-9">
                        <div className={`box-ratio-inner ${styles.imgWrap}`}>{mainImageComponent}</div>
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            </Card>
          </Col>
        </Row>
        {detailed && (
          <Row className={'mb-4'}>
            {roomTypes.map((roomType: accommodationRoomTypeObject, index: number) => {
              return (
                <Col xxl={6} className={styles.roomTypeWrap} key={index}>
                  <AccommodationRoomType roomType={roomType} index={index} />
                </Col>
              )
            })}
          </Row>
        )}
        {detailed && <AccommodationAvailableAddons addons={accommodation.availableAddons} />}
      </Container>
      {detailed && (
        <Container fluid className={styles.galleryContainer}>
          <Row>
            <Col className={'p-0'}>
              <GallerySlider gallery={accommodation.gallery} trackingStringPrefix={'travel_page:accommodation_room_type_slider'} />
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}

export default AccommodationDetailed
